import { MODEL_SPECS } from '../three/models';
import { DRESS_SCENES, PART_SCENES, PLACE_SCENES, ROOM_SCENES, SCENES } from './scenes';

export type SceneChoice = { id: string; label: string; group?: string; parts: readonly { id: string; label: string }[] };

const choice = (id: string): SceneChoice => ({
  id,
  label: SCENES[id].label,
  parts: SCENES[id].parts.map((p) => ({ id: p.id, label: p.label })),
});

export const PICTURE_CHOICES: readonly SceneChoice[] = [...PART_SCENES, ...DRESS_SCENES].map(choice);
export const FIND_CHOICES: readonly SceneChoice[] = PART_SCENES.map(choice);
export const ROOM_CHOICES: readonly SceneChoice[] = ROOM_SCENES.map(choice);
export const PLACE_CHOICES: readonly SceneChoice[] = PLACE_SCENES.map(choice);

export const MODEL_CHOICES: readonly SceneChoice[] = [
  {
    id: 'car3d',
    label: 'Car',
    group: 'Vehicles',
    parts: [
      { id: 'wheel', label: 'wheel' }, { id: 'door', label: 'door' }, { id: 'boot', label: 'boot' },
      { id: 'bonnet', label: 'bonnet' }, { id: 'headlight', label: 'headlight' }, { id: 'plate', label: 'number plate' },
      { id: 'exhaust', label: 'exhaust' }, { id: 'roof', label: 'roof' }, { id: 'windscreen', label: 'windscreen' },
    ],
  },
  {
    id: 'house3d',
    label: 'House',
    group: 'Buildings',
    parts: [
      { id: 'frontdoor', label: 'front door' }, { id: 'backdoor', label: 'back door' }, { id: 'chimney', label: 'chimney' },
      { id: 'roof', label: 'roof' }, { id: 'window', label: 'window' }, { id: 'garage', label: 'garage' },
      { id: 'tree', label: 'tree' }, { id: 'letterbox', label: 'letterbox' },
    ],
  },
  {
    id: 'plane3d',
    label: 'Aeroplane',
    group: 'Vehicles',
    parts: [
      { id: 'wing', label: 'wing' }, { id: 'tail', label: 'tail' }, { id: 'cockpit', label: 'cockpit' },
      { id: 'engine', label: 'engine' }, { id: 'wheels', label: 'wheels' }, { id: 'door', label: 'door' },
      { id: 'propeller', label: 'propeller' },
    ],
  },
  {
    id: 'teddy3d',
    label: 'Teddy bear',
    group: 'Toys',
    parts: [
      { id: 'ear', label: 'ear' }, { id: 'eye', label: 'eye' }, { id: 'nose', label: 'nose' }, { id: 'tummy', label: 'tummy' },
      { id: 'arm', label: 'arm' }, { id: 'leg', label: 'leg' }, { id: 'bow', label: 'bow' }, { id: 'tail', label: 'tail' },
    ],
  },
  {
    id: 'dog3d',
    label: 'Dog',
    group: 'Animals',
    parts: [
      { id: 'ear', label: 'ear' }, { id: 'eye', label: 'eye' }, { id: 'nose', label: 'nose' }, { id: 'tongue', label: 'tongue' },
      { id: 'collar', label: 'collar' }, { id: 'leg', label: 'leg' }, { id: 'tail', label: 'tail' }, { id: 'spot', label: 'spot' },
    ],
  },
  {
    id: 'bike3d',
    label: 'Bicycle',
    group: 'Vehicles',
    parts: [
      { id: 'wheel', label: 'wheel' }, { id: 'seat', label: 'seat' }, { id: 'handlebars', label: 'handlebars' }, { id: 'pedal', label: 'pedal' },
      { id: 'bell', label: 'bell' }, { id: 'basket', label: 'basket' }, { id: 'light', label: 'light' }, { id: 'reflector', label: 'red reflector' },
    ],
  },
  {
    id: 'boat3d',
    label: 'Sailing boat',
    group: 'Vehicles',
    parts: [
      { id: 'sail', label: 'sail' }, { id: 'mast', label: 'mast' }, { id: 'flag', label: 'flag' }, { id: 'anchor', label: 'anchor' },
      { id: 'window', label: 'round window' }, { id: 'lifebuoy', label: 'lifebuoy' }, { id: 'rudder', label: 'rudder' },
    ],
  },
  {
    id: 'fireengine3d',
    label: 'Fire engine',
    group: 'Vehicles',
    parts: [
      { id: 'ladder', label: 'ladder' }, { id: 'hose', label: 'hose' }, { id: 'bluelight', label: 'blue light' }, { id: 'wheel', label: 'wheel' },
      { id: 'door', label: 'door' }, { id: 'headlight', label: 'headlight' }, { id: 'bell', label: 'bell' },
    ],
  },
  {
    id: 'train3d',
    label: 'Steam train',
    group: 'Vehicles',
    parts: [
      { id: 'chimney', label: 'chimney' }, { id: 'cab', label: 'cab' }, { id: 'wheel', label: 'wheel' }, { id: 'buffer', label: 'buffer' },
      { id: 'whistle', label: 'whistle' }, { id: 'lamp', label: 'lamp' }, { id: 'coal', label: 'coal' }, { id: 'window', label: 'window' },
    ],
  },
  ...MODEL_SPECS.map((m) => ({ id: m.id, label: m.label, group: m.group, parts: Object.entries(m.parts).map(([id, label]) => ({ id, label })) })),
];
